import React from "react";
import TreeItem from "@material-ui/lab/TreeItem";

import TreeItemLabel from "./TreeItemLabel";
import TreeItemMiddle from "./TreeItemMiddle";

const TreeItemTop = ({
  nodes,
  selected,
  getOnChange,
  isOpenParent,
  setIsOpenParent,
  isOpenNestedParent,
  setIsOpenNestedParent,
}) => {
  const { id, children } = nodes;

  return (
    <TreeItem
      key={id}
      nodeId={id}
      label={
        <TreeItemLabel
          nodes={nodes}
          selected={selected}
          getOnChange={getOnChange}
          setIsOpenParent={setIsOpenParent}
        />
      }
      onClick={() => {
        isOpenParent[0] === id ? setIsOpenParent([]) : setIsOpenParent([id]);
      }}
    >
      {
        // Render only 1 element for tree build
        <TreeItemMiddle
          key={children[0].id}
          nodes={children[0]}
          getOnChange={getOnChange}
          selected={selected}
          isOpenNestedParent={isOpenNestedParent}
          setIsOpenNestedParent={setIsOpenNestedParent}
        />
      }
      {
        // Render all items except 1 if clicked parent node
        isOpenParent[0] === id &&
          children.map((node, i) => {
            if (i === 0) return null;
            return (
              <TreeItemMiddle
                key={node.id}
                nodes={node}
                getOnChange={getOnChange}
                selected={selected}
                isOpenNestedParent={isOpenNestedParent}
                setIsOpenNestedParent={setIsOpenNestedParent}
              />
            );
          })
      }
    </TreeItem>
  );
};

export default TreeItemTop;
